import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import './ForgotPassword.css';

const API_BASE = 'http://localhost:5001';

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ message: '', type: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email) {
      setStatus({ message: 'Veuillez renseigner votre adresse email.', type: 'error' });
      return;
    }

    setStatus({ message: '', type: '' });
    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE}/api/users/forgot-password`, { email });
      setStatus({ message: response.data?.message || 'Un nouveau mot de passe vient de vous être envoyé.', type: 'success' });
    } catch (err) {
      const message = err.response?.data?.error || 'Erreur lors de la réinitialisation du mot de passe.';
      setStatus({ message, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password">
      <div className="forgot-password__card">
        <h2 className="forgot-password__title">Mot de passe oublié ?</h2>
        <p className="forgot-password__subtitle">
          Indiquez l’adresse email associée à votre compte. Nous vous enverrons un nouveau mot de passe.
        </p>
        <form className="forgot-password__form" onSubmit={handleSubmit}>
          <label htmlFor="forgot-email" className="forgot-password__label">Adresse email</label>
          <input
            id="forgot-email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="forgot-password__input"
            placeholder="vous@entreprise.com"
            required
          />
          <button type="submit" className="forgot-password__submit" disabled={loading}>
            {loading ? 'Envoi...' : 'Envoyer'}
          </button>
          <button type="button" className="forgot-password__cancel" onClick={() => navigate('/login')}>
            Annuler
          </button>
          {status.message && (
            <p className={`forgot-password__message forgot-password__message--${status.type}`}>
              {status.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
